import React from "react";
import { Link } from "react-router-dom";

import { all_routes } from "../../../router/all_routes";

interface IssueKeyBadgeProps {
  projectKey: string;
  issueKey: string;
  className?: string;
}

const IssueKeyBadge: React.FC<IssueKeyBadgeProps> = ({
  projectKey,
  issueKey,
  className,
}) => {
  const path = all_routes.projectIssueDetails
    .replace(":projectKey", projectKey)
    .replace(":issueKey", issueKey);
  return (
    <Link
      to={path}
      className={`text-decoration-none small fw-semibold text-primary ${
        className || ""
      }`}
    >
      {issueKey}
    </Link>
  );
};

export default IssueKeyBadge;
